import React from 'react';
import ThisProject from '../ThisProject';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

        </div>
      )}
    </ThisProject>
  )
}

export default Content